import { getQueryClient } from '@/context/ReactQueryProvider';

import { QueryKeys } from '../query-keys';

export const resetQuantaQueries = () => {
  const queryClient = getQueryClient();
  queryClient.resetQueries({ queryKey: ['quanta-vault-claim'] });
  queryClient.resetQueries({ queryKey: ['quanta-migration-prompt'] });
  queryClient.resetQueries({ queryKey: [QueryKeys.quantaLogin] });
  queryClient.resetQueries({ queryKey: [QueryKeys.quantaCheck] });
  queryClient.resetQueries({ queryKey: [QueryKeys.quantaMissions] });
  queryClient.resetQueries({ queryKey: [QueryKeys.quantaSideMissions] });
  queryClient.resetQueries({ queryKey: [QueryKeys.quantaMissionTasks] });
  queryClient.resetQueries({ queryKey: [QueryKeys.quantaSideMissionTasks] });
  queryClient.resetQueries({ queryKey: [QueryKeys.quantaRanking] });
};
